export default "<p>No Data Available!</p>\r\n"